export type DescriptionVariant = {
  name: string
  value: string
}

export const CHARGE_VARIANTS: DescriptionVariant[] = [
  { name: 'Mês vencimento', value: '{{mes_vencimento}}/{{ano_vencimento}}' },
  {
    name: 'Mês anterior vencimento',
    value: '{{mes_anterior_vencimento}}/{{ano_anterior_vencimento}}'
  },
  { name: 'Itens da cobrança', value: '{{itens_da_cobranca}}' }
]

export const NFSE_ISSUE_VARIANTS: DescriptionVariant[] = [
  { name: 'Mês emissão', value: '{{mes_emissao}}/{{ano_emissao}}' },
  {
    name: 'Mês anterior emissão',
    value: '{{mes_anterior_emissao}}/{{ano_anterior_emissao}}'
  }
]

export const NFSE_DUE_DATE_VARIANTS: DescriptionVariant[] = [
  { name: 'Mês vencimento', value: '{{mes_vencimento}}/{{ano_vencimento}}' },
  {
    name: 'Mês anterior vencimento',
    value: '{{mes_anterior_vencimento}}/{{ano_anterior_vencimento}}'
  }
]

export const NFSE_DUE_DATE_TOKENS = [
  '{{mes_vencimento}}',
  '{{ano_vencimento}}',
  '{{mes_anterior_vencimento}}',
  '{{ano_anterior_vencimento}}'
]

export const hasNfseDueDateTokens = (description?: string): boolean =>
  NFSE_DUE_DATE_TOKENS.some((token) => (description || '').includes(token))

/**
 * Valida o FORMATO das variáveis numa descrição de NFSe.
 *
 * Espelha checkDescriptionVariant do charge
 * (BodyModalNewChargeOrRecurrence.utils.ts), com os tokens de NFSe: qualquer
 * `{{...}}` presente tem que casar com um par mês/ano conhecido. Pega typo
 * (`{{mes_emisao}}`) e par quebrado (`{{mes_vencimento}}` sem `{{ano_vencimento}}`)
 * — que hoje passariam batido e chegariam literais na discriminação fiscal.
 *
 * Retorna a mensagem de erro, ou null se está válido.
 */
export const validateNfseDescriptionVariants = (
  description?: string
): string | null => {
  const anyToken = /\{\{(\w+)/gm
  const validPairs =
    /(\{\{(mes_emissao|mes_anterior_emissao|mes_vencimento|mes_anterior_vencimento)\}\}.*\/.*\{\{(ano_emissao|ano_anterior_emissao|ano_vencimento|ano_anterior_vencimento)\}\})/g

  if (!description?.match(anyToken)) return null
  if (description.match(validPairs)) return null

  return 'Este modelo contém parâmetros de variável com formatação incorreta. Use o botão "Adicionar variável" para inserir uma variável válida. ex: {{mes_emissao}}/{{ano_emissao}}'
}
